import React from "react";
import { Icon } from "@chakra-ui/react";
import { MdPerson, MdHome, MdSettings } from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
import BuyTrade from "views/admin/trades/index";
import SellTrade from "views/admin/trades/selltrades";
import DisputedBuy from "views/admin/trades/disputedbuy";
import DisputedSell from "views/admin/trades/disputedsell";
import CompletedBuy from "views/admin/trades/completedbuy";
import CompletedSell from "views/admin/trades/completedsell";
import Users from "views/admin/users";
import Kyc from "views/admin/users/kyc";
import Settings from "views/admin/settings";

import UserDashboard from "views/user/dashboard";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdHome} width="20px" height="20px" color="white" />,
    component: <MainDashboard />,
    collapse: false,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "/users/index",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="white" />,
    component: <Users />,
    collapse: false,
  },
  {
    name: "Pending KYC",
    layout: "/admin",
    path: "/users/kyc",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="white" />,
    component: <Kyc />,
    collapse: false,
  },
  {
    name: "Admin Users",
    layout: "/admin",
    path: "/users/admin",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="white" />,
    component: <SellTrade />,
    collapse: false,
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "/settings",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="white" />,
    component: <Settings />,
    collapse: false,
  },
];

export default routes;
